import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { IMG, PARTNERS } from "@/lib/brand";
import { Section, PageHeader, Eyebrow } from "@/components/common";
import { ExternalLink } from "lucide-react";

export default function Label() {
  const [label, setLabel] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setLabel(r.data.label || {})).catch(() => setLabel({}));
  }, []);
  if (!label) return null;
  const isEmpty = (v) => !v || v.startsWith("À COMPLÉTER");

  const blocks = [
    ["Notre vision", label.vision],
    ["Nos activités", label.activities],
    ["Notre savoir-faire", label.savoir_faire],
  ];

  return (
    <div data-testid="label-page">
      <PageHeader eyebrow="Le Label" title="AL Music Records" subtitle={isEmpty(label.intro) ? "Structure indépendante spécialisée dans la production musicale et phonographique." : label.intro} image={IMG.vinyl} />
      <Section className="py-20 space-y-16">
        {blocks.filter(([, content]) => !isEmpty(content)).map(([title, content]) => (
          <div key={title} className="grid lg:grid-cols-[280px_1fr] gap-8 border-b border-white/5 pb-14">
            <div>
              <Eyebrow>{title}</Eyebrow>
              <h2 className="font-display font-extrabold text-2xl sm:text-3xl">{title}</h2>
            </div>
            <div className="text-slate-300 leading-relaxed whitespace-pre-line">
              {content}
            </div>
          </div>
        ))}
        <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-8 sm:p-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
          <div>
            <Eyebrow>Le label en action</Eyebrow>
            <h2 className="font-display font-extrabold text-2xl sm:text-3xl">Nos artistes & projets</h2>
            <p className="text-slate-400 mt-2 max-w-xl">Découvrez les artistes développés par AL Music Records et leurs projets.</p>
          </div>
          <Link to="/label/artistes" data-testid="label-artists-cta" className="btn-gold shrink-0">Voir les artistes & projets</Link>
        </div>

        <div data-testid="partners-section">
          <Eyebrow>Partenaires & Références</Eyebrow>
          <h2 className="font-display font-extrabold text-2xl sm:text-3xl mb-8">Ils nous font confiance</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="partners-grid">
            {PARTNERS.map((p) =>
              p.url ? (
                <a
                  key={p.name}
                  href={p.url}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`partner-link-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`}
                  className="card-dark p-6 flex items-center justify-between gap-3 group hover:!border-amber-400/50 hover:bg-white/[0.03] transition-colors"
                >
                  <span className="font-display font-bold text-sm sm:text-base">{p.name}</span>
                  <ExternalLink size={16} className="shrink-0 text-slate-500 group-hover:text-gold transition-colors" />
                </a>
              ) : (
                <div
                  key={p.name}
                  data-testid={`partner-static-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "")}`}
                  className="rounded-xl border border-white/10 bg-white/[0.02] p-6 flex items-center"
                >
                  <span className="font-display font-bold text-sm sm:text-base text-slate-300">{p.name}</span>
                </div>
              )
            )}
          </div>
        </div>
      </Section>
    </div>
  );
}
